export default __webpack_public_path__ + "static/media/Version (2) - LOTR_01.f28231fc.jpg";